import {useMemo} from "react";

export const getGridColumnDimensions = (lookViewType) => {
  // Define column and row settings based on lookViewType
  switch (lookViewType) {
    case 1:
      return {columnCount: 1, rowHeight: 104}
    case 2:
      return {columnCount: 2, rowHeight: 170}
    case 3:
      return {columnCount: 1, rowHeight: 320} // Increased row height
    case 4:
      return {columnCount: 3, rowHeight: 128}
    default:
      return {columnCount: 1, rowHeight: 135}
  }
}

export const useGridDimensions = (windowHeight, isMobile) => {
  const gridWidth = useMemo(() => isMobile ? 238 : 296, [isMobile]);
  const gridHeight = useMemo(() => {
    if (isMobile) {
      return windowHeight - 74 // 50 header + 24 footer info bar
    }
    return windowHeight - 110 // 50 header + 60 footer
  }, [windowHeight, isMobile]);

  return {gridWidth, gridHeight}
}
